import { PDFFormType } from '@models/matter-form-data';

export class SelectForm {
	static readonly type = '[selectedMatterForms] select Form';
	constructor(
		public payload: {
			formType: PDFFormType;
			formId?: string;
			mortgageId?: string;
		},
	) {}
}

export class SetSelectedFormField {
	static readonly type = '[selectedMatterForms] set selected form field';
	constructor(public payload: { field: string; value: string }) {}
}
